import { render, staticRenderFns } from "./multiUpload.vue?vue&type=template&id=1db842d0&"
import script from "./multiUpload.vue?vue&type=script&lang=js&"
export * from "./multiUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports